import { useInfoLimitesClasse } from "./use-info-limites-classe";
import { InfoLimitesClasseView } from "./view-info-limites-classe";
import type { InfoLimitesClasseProps } from "./types-info-limites-classe";

export function InfoLimitesClasse(props: InfoLimitesClasseProps) {
  const vm = useInfoLimitesClasse(props);

  return <InfoLimitesClasseView {...props} {...vm} />;
}

export type * from "./types-info-limites-classe";
